<template>
  <form>
    <InputField
      v-model="innerName"
      name="名前"
      label="名前"
      :disabled="true"
      full-width
    />
    <InputField
      v-model="innerAdvertiser"
      name="広告アカウント"
      label="広告アカウント"
      class="mt-4"
      :disabled="true"
      full-width
    />
    <SelectField
      v-model="innerAdType"
      name="広告タイプ"
      label="広告タイプ"
      rules="required"
      class="mt-4"
      :options="optionAdTypes"
      :searchable="false"
      full-width
    />
    <div v-if="innerAdType == 'SP'">
      <SelectField
        v-model="innerCampaign"
        name="キャンペーン"
        label="キャンペーン"
        rules="required"
        class="mt-4"
        :options="optionCampaignsSp"
        :searchable="true"
        full-width
      />
    </div>
    <div v-if="innerAdType == 'SB'">
      <SelectField
        v-model="innerCampaign"
        name="キャンペーン"
        label="キャンペーン"
        rules="required"
        class="mt-4"
        :options="optionCampaignsSb"
        :searchable="true"
        full-width
      />
    </div>
    <div v-if="innerAdType == 'SP' || innerAdType == 'SB'">
      <InputField
        v-model.number="innerBidAjustment"
        type="number"
        name="入札額調整"
        label="入札額調整"
        rules="required|integer|min_value:0|max_value:900"
        class="mt-4"
        full-width
      />
    </div>
    <div v-if="innerAdType == 'SD'">
      <SelectField
        v-model="innerCampaignAndAdGroup"
        name="キャンペーン＞広告グループ"
        label="キャンペーン＞広告グループ"
        rules="required"
        class="mt-4"
        :options="optionGroups"
        :searchable="true"
        full-width
      />
      <InputField
        v-model.number="innerBid"
        type="number"
        name="入札金額"
        label="入札金額"
        rules="required|integer|min_value:2|max_value:200"
        class="mt-4"
        full-width
      />
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import InputField from '@/components/fields/InputField'
import SelectField from '@/components/fields/SelectField'

export default {
  name: 'AmcAudienceDeliveryRegisterForm',
  components: {
    InputField,
    SelectField
  },
  props: {
    name: {
      type: String,
      default: null
    },
    advertiserId: {
      type: String,
      default: null
    },
    adType: {
      type: String,
      default: null
    },
    campaignId: {
      type: String,
      default: null
    },
    bidAjustment: {
      type: Number,
      default: null
    },
    campaignAndAdGroup: {
      type: String,
      default: null
    },
    bid: {
      type: Number,
      default: null
    }
  },
  emits: [
    'update:ad-type',
    'update:campaign-id',
    'update:campaign-name',
    'update:bid-ajustment',
    'update:campaign-and-ad-group',
    'update:ad-group-id',
    'update:ad-group-name',
    'update:bid'
  ],
  computed: {
    ...mapState('amcAudience', ['adCampaignList', 'adCampaignGroupList']),
    innerName: {
      get () {
        return this.name
      },
      set () {
      }
    },
    innerAdvertiser: {
      get () {
        return this.advertiserId
      },
      set () {
      }
    },
    innerAdType: {
      get () {
        return this.adType
      },
      set (val) {
        this.$emit('update:ad-type', val)
      }
    },
    innerCampaign: {
      get () {
        return this.campaignId
      },
      set (val) {
        this.$emit('update:campaign-id', val)
        const campaign = this.adCampaignList.find(c => c.campaignId == val)
        if (!campaign) {
          this.$emit('update:campaign-name', null)
        } else {
          this.$emit('update:campaign-name', campaign['campaignName'])
        }
      }
    },
    innerBidAjustment: {
      get () {
        return this.bidAjustment
      },
      set (val) {
        this.$emit('update:bid-ajustment', val)
      }
    },
    innerCampaignAndAdGroup: {
      get () {
        return this.campaignAndAdGroup
      },
      set (val) {
        this.$emit('update:campaign-and-ad-group', val)
        if (!val) {
          this.$emit('update:campaign-id', null)
          this.$emit('update:campaign-name', null)
          this.$emit('update:ad-group-id', null)
          this.$emit('update:ad-group-name', null)
        } else {
          const [campaignId, adGroupId] = val.split('_')
          const campaignAndAdGroup = this.adCampaignGroupList.find(c => c.campaignId == campaignId && c.adGroupId == adGroupId)
          if (campaignAndAdGroup) {
            const { campaignName, adGroupName } = campaignAndAdGroup
            this.$emit('update:campaign-id', campaignId)
            this.$emit('update:campaign-name', campaignName)
            this.$emit('update:ad-group-id', adGroupId)
            this.$emit('update:ad-group-name', adGroupName)
          }
        }
      }
    },
    innerBid: {
      get () {
        return this.bid
      },
      set (val) {
        this.$emit('update:bid', val)
      }
    },
    optionAdTypes () {
      return [
        {text: 'Sponsor Product', value: 'SP'},
        {text: 'Sponsor Brand', value: 'SB'},
        {text: 'Sponsor Display', value: 'SD'}
      ]
    },
    optionCampaignsSp () {
      return this.adCampaignList.filter(({type}) => type === 'SP').map(
        ({campaignId, campaignName}) => ({
          text: campaignName, value: campaignId
        })
      );
    },
    optionCampaignsSb () {
      return this.adCampaignList.filter(({type}) => type === 'SB').map(
        ({campaignId, campaignName}) => ({
          text: campaignName, value: campaignId
        })
      );
    },
    optionGroups () {
      return this.adCampaignGroupList.map(
        ({campaignId, campaignName, adGroupId, adGroupName}) => ({
          text: `${campaignName}＞${adGroupName}`, value: `${campaignId}_${adGroupId}`
        })
      );
    }
  }
}
</script>
